/**
 * Hook misji „Przymierz ubranko w sklepie" — tylko EMIT (W9-B / QuestLayer).
 */
export const INTERACT_BUS_EVENT = 'pieskowo:interact';
export const SHOP_QUEST_ID = 'shop_try_on' as const;

export type ShopMissionPayload = {
  sceneKey: 'Shop';
  questId: typeof SHOP_QUEST_ID;
  stepKind: 'try_on';
  itemId: string;
};

/**
 * Payload po udanym przymierzeniu. Brak itemId → null.
 */
export function shopMissionFromTryOn(itemId: string): ShopMissionPayload | null {
  if (!itemId) return null;
  return {
    sceneKey: 'Shop',
    questId: SHOP_QUEST_ID,
    stepKind: 'try_on',
    itemId,
  };
}
